import { http } from "@/api/client";
import type { ApiItemResponse, ApiListResponse } from "@/api/types";
import type { ShareRecord } from "@/types/domain";

export const shareRecordsApi = {
  list: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<ShareRecord>>("/api/share-records", query),
};

export const analyticsApi = {
  overview: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiItemResponse<unknown>>("/api/analytics/overview", query),
  funnel: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiItemResponse<unknown>>("/api/analytics/funnel", query),
  channels: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiItemResponse<unknown>>("/api/analytics/channels", query),
  trends: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiItemResponse<unknown>>("/api/analytics/trends", query),
  paths: () => http.get<ApiItemResponse<unknown>>("/api/analytics/paths"),
  ltv: () => http.get<ApiItemResponse<unknown>>("/api/analytics/ltv"),
  retention: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiItemResponse<unknown>>("/api/analytics/retention", query),
  shareDetails: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<ShareRecord>>("/api/analytics/share-details", query),
  export: (body?: unknown) => http.post<ApiItemResponse<{ jobId: string; status: string; format: string }>>("/api/analytics/export", body),
};

export const sdkApi = {
  releases: () => http.get<ApiItemResponse<unknown>>("/api/sdk/releases"),
  monitor: () => http.get<ApiItemResponse<unknown>>("/api/sdk/monitor"),
  monitorSummary: () => http.get<ApiItemResponse<unknown>>("/api/sdk/monitor/summary"),
  monitorApis: () => http.get<ApiItemResponse<unknown>>("/api/sdk/monitor/apis"),
  monitorErrors: () => http.get<ApiItemResponse<unknown>>("/api/sdk/monitor/errors"),
};

export const adminApi = {
  listChannels: () => http.get<ApiItemResponse<unknown>>("/api/admin/channels"),
  getChannel: (code: string) => http.get<ApiItemResponse<unknown>>(`/api/admin/channels/${code}`),
  updateChannel: (code: string, body: unknown) => http.patch<ApiItemResponse<unknown>>(`/api/admin/channels/${code}`, body),
  listUsers: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<unknown>>("/api/admin/users", query),
  createUser: (body: unknown) => http.post<ApiItemResponse<unknown>>("/api/admin/users", body),
  updateUser: (id: string, body: unknown) => http.patch<ApiItemResponse<unknown>>(`/api/admin/users/${id}`, body),
  listAuditLogs: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<unknown>>("/api/admin/audit-logs", query),
  createAuditLog: (body: unknown) => http.post<ApiItemResponse<unknown>>("/api/admin/audit-logs", body),
  platformHealth: () => http.get<ApiItemResponse<unknown>>("/api/admin/platform/health"),
  platformStats: () => http.get<ApiItemResponse<unknown>>("/api/admin/platform/stats"),
  getSystemSettings: () => http.get<ApiItemResponse<unknown>>("/api/admin/settings/system"),
  updateSystemSettings: (body: unknown) => http.patch<ApiItemResponse<unknown>>("/api/admin/settings/system", body),
  listCredentials: () => http.get<ApiListResponse<unknown>>("/api/admin/credentials"),
  listConfigSchemas: () => http.get<ApiListResponse<unknown>>("/api/admin/config-schemas"),
};
